import React, { MouseEventHandler, useCallback } from 'react';
import { Button, ButtonProps } from '@cp/ds/src/components/button';
import { useStartCall } from '../model';

export interface StartCallButtonProps extends ButtonProps {
  interactionId: number;
}

export const StartCallButton = ({ interactionId, ...props }: StartCallButtonProps) => {
  const { startCall, isLoading } = useStartCall(interactionId);

  const onClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      e.stopPropagation();
      void startCall();
    },
    [startCall],
  );

  return (
    <Button
      aria-label="Няняфон"
      disabled={isLoading}
      onClick={onClick}
      {...props}
      title={props.title ?? 'Няняфон'}
    />
  );
};
